import React, {Component} from 'react';
import { Button, IconButton, Box, Grid } from '@material-ui/core';
import { AddCircleOutlineRounded, RemoveCircleOutlineRounded } from '@material-ui/icons';
import InputText, { InputSelectNative } from '../../../commonModules/interface/form-input-inline';

const Counter = ({onIncrement, onDecrement}) => (
    <div className="text-center">
        <IconButton color="primary" onClick={onIncrement} title="Ajouter un champ">
            {/* <i className="zmdi zmdi-plus-circle"></i> */}
            <AddCircleOutlineRounded />
        </IconButton>
        <IconButton color="secondary" onClick={onDecrement} title="Supprimer un champ">
            {/* <i className="zmdi zmdi-minus-circle-outline"></i> */}
            <RemoveCircleOutlineRounded />
        </IconButton>
    </div>
);
const hasOptions = [
    "select",
    "radio",
    "checkbox",
]
const Element = ({info, onChangeInfo, sav}) => (
    <Grid container style={{backgroundColor: info.id % 2 === 0 ? "lightyellow": "", width:"100%", padding:"10px"}}>
        <Grid item sm={4} xs={12}>
            <InputSelectNative
                label="Type de champ"
                onChange={onChangeInfo}
                name="type"
                value={ info.type }
                options={[
                    <option value="string">Texte</option>,
                    <option value="number">Nombre</option>,
                    <option value="datetime">Date</option>,
                    !sav && <option value="file">Download</option>,
                    <option value="checkbox">Cases à cocher (plusieurs réponses possibles)</option>,
                    <option value="select">Liste déroulante (une seule réponse)</option>,
                    <option value="radio">Liste de choix Bouton (une seule réponse)</option>,
                    <option value="integerSlider">Nombre à glissière</option>,
                    <option value="password">Mot de Passe</option>
                ]}
            />
            
        </Grid>
        
        <Grid item sm={2} xs={12}>
            <InputSelectNative
                label="Obligatoire ?"
                name="mandatory"
                onChange={onChangeInfo}
                value={info.mandatory}
                options={[
                    <option value="yes">Obligatoire</option>,
                    <option value="no">Optionel</option>
                ]}
            />
            
        </Grid>

        {/* <div className="col-sm-2 col-xs-12">
            <div className="fg-line select">
                <select className="form-control" 
                name="mandatory"
                    onChange={onChangeInfo}
                    value={info.mandatory}
                >
                    <option value="yes">Obligatoire</option>
                    <option value="no">Optionel</option>
                </select>
            </div>
        </div> */}
        <Grid item sm={6} xs={12}>
            <InputText
                type="text"
                name="name"
                placeholder="Nom du champ"
                label="Nom du champ"
                value={info.name}
                onChange={onChangeInfo}/>
        </Grid>

            
        { hasOptions.includes(info.type)  &&
        <Grid item xs={12}>
            <InputText
                lebel="Options"
                type="text"
                name="option"
                placeholder="Option1,Option2,Option3"
                value={info.option}
                onChange={onChangeInfo}
            />
        </Grid> 
        // <div className="col-xs-12">
        //     <div className="fg-line">
        //         <input
        //             type="text"
        //             name="option"
        //             className="form-control"
        //             placeholder="Option1,Option2,Option3"
        //             value={info.option}
        //             onChange={onChangeInfo} />
        //     </div>
        // </div>
        }
        
    </Grid>
);

class NewFormElement extends Component{
    state = {
        formTitle: "",
        formSubTitle: "",
        name: "",
        info: [
            {
                id: 1,
                type: "string",
                mandatory: "yes",
                name: "",
                option: "",
            }
        ]
    }
    getLastId = () => {
        let lastID = 0;
        this.state.info.map( item => {
            if (item.id > lastID) {
                lastID = item.id;
            }
        })
        return lastID;
    }
    addElement = (action) => {
        console.log('Add Element,', action);
        if (action.type === 'INCREMENT') {
            this.setState({
                info: this.state.info.concat({
                    id: this.getLastId() + 1,
                    type: "string",
                    mandatory: "yes",
                    name: "",
                    option: "",
                })
            })
        } else if (action.type === 'DECREMENT') {
            let lastIndex = this.state.info.length - 1;
            console.log('[DEBUG], remove index', lastIndex);
            this.setState({
                info: this.state.info.slice(0, -1)
            })
        }
    }
    updateElement = (e, newInfo) => {

        let name = e.target.name
        let value = e.target.value

        console.log('Update Info,', newInfo, ' for ', name, ', and', value);

        newInfo[name] = value
        
        console.log('Info to update : ', newInfo);

        let newInfoFinal = this.state.info.slice(0, newInfo.id-1)
        .concat(newInfo)
        .concat(this.state.info.slice(newInfo.id));
        
        console.log('Info to update : ', newInfoFinal);
        this.setState({
            info: newInfoFinal
        })
    }
    parseOption =  (option) => {
        let response = option.split(",");
        return response;
    }
    getAllRequired = () => {
        let response = [];
        this.state.info.map( item => {
            if (item.mandatory === "yes"){
                response.push(item.name);                
            }
        })
        return response;
    }
    getAllProperties=  () => {
        let obj = {};
        let uiSchema = {};

        this.state.info.map( item => {
            let itemType = item.type;
            if(item.name === ""){
                return;
            }
            if (typeof uiSchema["ui:order"] === "undefined"){
                uiSchema["ui:order"] = [item.name]
            }else{
                uiSchema["ui:order"] = [].concat(uiSchema["ui:order"], item.name)
            }
            obj[item.name] = {
                "title": item.name,
                "type": itemType
            };  
            switch (item.type){
                case "checkbox":
                    uiSchema[item.name] = {"ui:widget": "checkboxes"};               
                    obj[item.name].type = "array"; 
                    obj[item.name].items = {"type":"string","enum": this.parseOption(item.option) };                    
                    obj[item.name].uniqueItems = true ;
                    break;
                case "select":
                    uiSchema[item.name] = {"ui:widget": "select", "ui:placeholder": "Choisissez"};               
                    obj[item.name].type = "string"; 
                    obj[item.name].enum = this.parseOption(item.option);
                    break;
                case "radio":
                    uiSchema[item.name] = {"ui:widget": "radio", "ui:placeholder": "Choisissez"};
                    obj[item.name].type = "string"; 
                    obj[item.name].enum = this.parseOption(item.option);
                    break;
                case "integerSlider":
                    uiSchema[item.name] = {"ui:widget": "range"};
                    obj[item.name].type = "integer";
                    break;                       
                case "password":
                    uiSchema[item.name] = {"ui:widget": "password"};
                    obj[item.name].type = "string";  
                    break;                       
                case "file":
                    obj[item.name].type = "string";  
                    obj[item.name].format = "data-url";
                    break;   
                case "datetime":
                    obj[item.name].type = "string";  
                    obj[item.name].format = "date";
                    break;  
            }
   
        })
        return {
            properties : obj,
            uiSchema : uiSchema
        };
    }
    parseJsonForm=  () => {
        let properties ={};
        let res = this.getAllProperties();
        properties = res.properties;
        let uiSchema = res.uiSchema;
        let jsonSchemaCreated = {
            "title": this.state.formTitle,
            "description": this.state.formSubTitle,
            "type": "object",
            "required": this.getAllRequired(),     
            "properties":  properties,
        };
        return {
            jsonSchema: jsonSchemaCreated,
            uiSchema : uiSchema,
            name: this.state.name
        };
    }
    onClose=  (e) => {
        e.preventDefault();
        console.log("Close Object");
        this.setState({ formTitle: "", formSubTitle: "", name: "", info: [ { id: 1, type: "string", mandatory: "yes", name: "", option: "", } ] });
        //this.setState({popupState: "overlay hidden", popupStateValidation: "overlay hidden"});
        this.props.onClose();
    }
    prepareRequest=  (e) => {
        e.preventDefault();
        let json = this.parseJsonForm();
        this.props.validation(json);
    }
    render() {
        console.log('Info on new Element :', this.state.info, " parsed to : ", this.parseJsonForm());
        return (
            <Box>
                <Box p={2}>
                    <InputText
                        label="Id Questionnaire"
                        placeholder="Q_commercial_1"                                
                        value={this.state.name}
                        onChange={e => this.setState({ name: e.target.value })}
                    />
                    <InputText
                        label="Titre Questionnaire"
                        placeholder="Validez vos informations"                                
                        value={this.state.formTitle}
                        onChange={e => this.setState({ formTitle: e.target.value })}
                    />
                    <InputText
                        label="Description"
                        placeholder="Information utiles : * signifie obligatoire"                          
                        value={this.state.formSubTitle}
                        onChange={e => this.setState({ formSubTitle: e.target.value })}
                    />

            {/* <div className="container">
                <div className="m-10">
                    <p className="c-black f-500 m-b-20">ID Questionnaire</p>
                    <div className="form-group">
                        <div className="fg-line">
                            <input
                                type="text"
                                className="form-control fg-input"
                                placeholder="Q_commercial_1"                                
                                value={this.state.name}
                                onChange={e => this.setState({name: e.target.value})}/>
                        </div>
                    </div> */}
                    {/* <p className="c-black f-500 m-b-20">Titre Questionnaire</p>
                    <div className="form-group">
                        <div className="fg-line">
                            <input
                                type="text"
                                className="form-control fg-input"
                                placeholder="Validez vos informations"                                                                
                                value={this.state.formTitle}
                                onChange={e => this.setState({formTitle: e.target.value})}/>
                        </div>
                    </div> */}
                    {/* <p className="c-black f-500 m-b-20">Description</p>
                    <div className="form-group">
                        <div className="fg-line">
                            <input
                                type="text"
                                className="form-control fg-input"
                                placeholder="Information utiles : * signifie obligatoire"                                                                
                                value={this.state.formSubTitle}
                                onChange={e => this.setState({formSubTitle: e.target.value})}/>
                        </div>
                    </div> */}
                    {/* <Grid container spacing={2}> */}
                        {this.state.info.map( item => (
                            <Element
                                info={item}
                                sav={this.props.sav}
                                onChangeInfo = {(e) => this.updateElement(e, item)}
                            />
                            ))
                        }
                    {/* </Grid> */}
                    <br/>
                    <br/>
                    <Counter
                        onIncrement={() => this.addElement({type: 'INCREMENT'})}
                        onDecrement={() => this.addElement({type: 'DECREMENT'})}
                    />
                </Box>

                <Box className="text-right">
                    <Button variant="contained" color="secondary" type="button" onClick={this.prepareRequest}>
                           Valider
                    </Button>
                    <Button
                        type="button"
                        onClick={this.onClose}
                    >
                        Annuler
                    </Button>
                </Box>
            </Box>
        )
    }
};

export default NewFormElement





// 'use strict';

// import React, {Component} from 'react';
// import createReactClass from 'create-react-class';

// import ValidationOverlay from './validationOverlay.jsx';

// const Counter = ({onIncrement, onDecrement}) => (
//     <div>
//         <p></p>
//         <button className="btn btn-info btn-icon waves-effect waves-circle waves-float" onClick={onDecrement}><i className="zmdi zmdi-minus-circle-outline"></i></button>
//         <button className="btn btn-danger btn-icon waves-effect waves-circle waves-float" onClick={onIncrement}><i className="zmdi zmdi-plus-circle"></i>
// </button>
//     </div>
// );

// const Element = ({info, onChangeInfo, sav}) => (
//     <div className="input-group">
//         <span className="input-group-addon">
//             <i className="zmdi zmdi-arrow-right"></i>
//         </span>
//         <div className="col-sm-2">
//             <div className="fg-line select">
//                 <select 
//                     className="form-control" 
//                     onChange={(e) => onChangeInfo(e, info,"TYPE")}
//                     value={info.type}
//                 >
//                     <option value="string">texte</option>
//                     <option value="number">nombre</option>
//                     <option value="datetime">date</option>
//                     {/*<option value="file">Photo</option>*/}
//                     {!sav &&
//                     <option value="file">Download</option>
//                     }
//                     <option value="listeChoise">Liste de choix</option>
//                     <option value="integerSlider">nombre à glissière</option>

//                     <option value="password">password</option>
//                 </select>
//             </div>
//         </div>
//         <div className="col-sm-2">
//             <div className="fg-line select">
//                 <select className="form-control" 
//                 onChange={(e) => onChangeInfo(e, info,"REQUIRED")}
//                  value={info.mandatory}>
//                     <option value="yes" >Obligatoire</option>
//                     <option value="no" >Optionel</option>
//                 </select>
//             </div>
//         </div>
//         <div className="col-sm-4">
//             <div className="fg-line">
//                 <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Name"
//                     value={info.name}
//                     onChange={(e) => onChangeInfo(e, info,"NAME")}/>
//             </div>
//         </div>
//         {(info.type == "listeChoise") ?  <div className="col-sm-4">
//             <div className="fg-line">
//                 <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Option1,Option2,Option3"
//                     value={info.option}
//                     onChange={(e) => onChangeInfo(e, info,"OPTION")}/>
//             </div>
//         </div>
//          : ""   }
//     </div>
// );

// class NewFormElement extends Component{
// state ={
//             formTitle: "",
//             formSubTitle: "",
//             name: "",
//             info: [
//                 {
//                     id: 1,
//                     type: "string",
//                     mandatory: "yes",
//                     name: "",
//                     option: "",
//                 }
//             ]
//         }
//     getLastId= () => {
//         let lastID = 0;
//         this
//             .state
//             .info
//             .map((item) => {
//                 if (item.id > lastID) {
//                     lastID = item.id;
//                 }
//             })
//         return lastID;
//     }
//     addElement= (action) => {
//         console.log('Add Element,', action);
//         if (action.type === 'INCREMENT') {
//             this.setState({
//                 info: this
//                     .state
//                     .info
//                     .concat({
//                         id: this.getLastId() + 1,
//                         type: "string",
//                         mandatory: "yes",
//                         name: "",
//                         option: "",
//                     })
//             })
//         } else if (action.type === 'DECREMENT') {
//             let lastIndex = this.state.info.lenght - 1;
//             console.log('[DEBUG], remove index', lastIndex);
//             this.setState({
//                 info: this
//                     .state
//                     .info
//                     .slice(0, -1)
//             })
//         }
//     }
//     updateElement=  (action) => {
//         console.log('Update Info,', action.info, ' for ', action.changeType, ', and',action.index);
//         let newInfo = action.info;
//         if (action.changeType === 'NAME'){
//             newInfo.name =  action.index;           
//         }else if (action.changeType === 'TYPE'){
//             newInfo.type = action.index;
//         }else if (action.changeType === 'OPTION'){
//             newInfo.option = action.index;            
//         }else {
//             newInfo.mandatory = action.index;
//         }
//         console.log('Info to update : ',newInfo);
//         let newInfoFinal = this
//         .state
//         .info
//         .slice(0,action.info.id-1).concat(newInfo).concat(this
//             .state
//             .info
//             .slice(action.info.id));
//             console.log('Info to update : ',newInfoFinal);
            
//         this.setState({
//             info: newInfoFinal
//         })
//     }
//     parseOption=  (option) => {
//         let response = option.split(",");
//         return response;
//     }
//     getAllRequired=  () => {
//         let response = [];
//         this
//         .state
//         .info.map((item) => {
//             if (item.mandatory === "yes"){
//                 response.push(item.name);                
//             }
//         })
//         return response;
//     }
//     getAllProperties=  () => {
//         let obj = {};
//         let uiSchema = {};
//         this
//         .state
//         .info.map((item) => {
//             let itemType = item.type;
//             if(item.name === ""){
//                 return;
//             }
//             if (typeof uiSchema["ui:order"] === "undefined"){
//                 uiSchema["ui:order"] = [item.name]
//             }else{
//                 uiSchema["ui:order"] = [].concat(uiSchema["ui:order"], item.name)
//             }
//             obj[item.name] = {
//                 "title": item.name,
//                 "type": itemType
//             };  
//             switch (item.type){
//                 case "listeChoise":
//                     uiSchema[item.name] = {"ui:widget": "checkboxes"};               
//                     obj[item.name].type = "array"; 
//                     obj[item.name].items = {"type":"string","enum": this.parseOption(item.option) };                    
//                     obj[item.name].uniqueItems = true ;
//                     break;
//                 case "option":
//                     uiSchema[item.name] = {"ui:placeholder": "Choose one"};
//                     obj[item.name].type = "string"; 
//                     obj[item.name].enum = his.parseOption(item.option);
//                     break;
//                 case "integerSlider":
//                     uiSchema[item.name] = {"ui:widget": "range"};
//                     obj[item.name].type = "integer";
//                     break;                       
//                 case "password":
//                     uiSchema[item.name] = {"ui:widget": "password"};
//                     obj[item.name].type = "string";  
//                     break;                       
//                 case "file":
//                     obj[item.name].type = "string";  
//                     obj[item.name].format = "data-url";
//                     break;   
//                 case "datetime":
//                     obj[item.name].type = "string";  
//                     obj[item.name].format = "date";
//                     break;  
//             }
   
//         })
//         return {
//             properties : obj,
//             uiSchema : uiSchema
//         };
//     }
//     parseJsonForm=  () => {
//         let properties ={};
//         let res = this.getAllProperties();
//         properties = res.properties;
//         let uiSchema = res.uiSchema;
//         let jsonSchemaCreated = {
//             "title": this.state.formTitle,
//             "description": this.state.formSubTitle,
//             "type": "object",
//             "required": this.getAllRequired(),     
//             "properties":  properties,
//         };
//         return {
//             jsonSchema: jsonSchemaCreated,
//             uiSchema : uiSchema,
//             name: this.state.name
//         };
//     }
//     onClose=  (e) => {
//         e.preventDefault();
//         console.log("Close Object");
//         this.setState({ formTitle: "", formSubTitle: "", name: "", info: [ { id: 1, type: "string", mandatory: "yes", name: "", option: "", } ] });
//         //this.setState({popupState: "overlay hidden", popupStateValidation: "overlay hidden"});
//         this
//             .props
//             .onClose();
//     }
//     prepareRequest=  (e) => {
//         e.preventDefault();
//         let json = this.parseJsonForm();
//         this
//         .props
//         .validation(json);
//     }
//     render() {
//         console.log('Info on new Element :', this.state.info, " parsed to : ", this.parseJsonForm());
//         return (
//             <div>
//                 <div className="col-sm-12">
//                     {/* Information that are mandatory*/}
//                     <p className="c-black f-500 m-b-20">ID Questionnaire</p>
//                     <div className="form-group">
//                         <div className="fg-line">
//                             <input
//                                 type="text"
//                                 className="form-control fg-input"
//                                 placeholder="Q_commercial_1"                                
//                                 value={this.state.name}
//                                 onChange={e => this.setState({name: e.target.value})}/>
//                         </div>
//                     </div>
//                     <p className="c-black f-500 m-b-20">Titre Questionnaire</p>
//                     <div className="form-group">
//                         <div className="fg-line">
//                             <input
//                                 type="text"
//                                 className="form-control fg-input"
//                                 placeholder="Validez vos informations"                                                                
//                                 value={this.state.formTitle}
//                                 onChange={e => this.setState({formTitle: e.target.value})}/>
//                         </div>
//                     </div>
//                     <p className="c-black f-500 m-b-20">Description</p>
//                     <div className="form-group">
//                         <div className="fg-line">
//                             <input
//                                 type="text"
//                                 className="form-control fg-input"
//                                 placeholder="Information utiles : * signifie obligatoire"                                                                
//                                 value={this.state.formSubTitle}
//                                 onChange={e => this.setState({formSubTitle: e.target.value})}/>
//                         </div>
//                     </div>
//                     {this
//                         .state
//                         .info
//                         .map((item) => (<Element
//                             info={item}
//                             sav={this.props.sav}
//                             onChangeInfo={(e, info,changeType) => {
//                             console.log(e.target.value);
//                             this.updateElement({index: e.target.value, info: info,changeType:changeType})
//                         }}/>))
// }
//                     <p> </p>
//                     <Counter
//                         onIncrement={() => this.addElement({type: 'INCREMENT'})}
//                         onDecrement={() => this.addElement({type: 'DECREMENT'})}/>
//                 </div>
//                 <p> </p>

//                 <div>
//                         <button className="btn btn-default btn-icon-text waves-effect" type="button"
//                             onClick={this.prepareRequest}>
//                             <i className="zmdi zmdi-check-all"></i>Submit</button>
//                         <button
//                             className="btn btn-default btn-icon-text waves-effect"
//                             type="button"
//                             onClick={this.onClose}>
//                             <i className="zmdi zmdi-close-circle-o"></i>
//                             Cancel
//                         </button>
//                     </div>
//                     <p> </p>
//             </div>
//         )
//     }
// };

// export default NewFormElement

// //module.exports = NewFormElement;
